/**
 * SendPaymentLinkDialog - Dialog to send payment link to customer
 * Extracted from CustomersPage.js
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const SendPaymentLinkDialog = ({
  open,
  onOpenChange,
  selectedCustomer,
  onSendPaymentLink
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Payment-Link an Kunde senden</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800 font-semibold mb-3">
              Der Payment-Link wird versendet an:
            </p>
            
            {/* Email Display */}
            {selectedCustomer?.email && (
              <div className="bg-white rounded border border-blue-300 p-3 mb-2">
                <div className="flex items-center gap-3">
                  <span className="text-2xl">📧</span>
                  <div className="flex-1">
                    <div className="font-semibold text-sm">Email</div>
                    <div className="text-xs text-gray-600">{selectedCustomer.email}</div>
                  </div>
                </div>
              </div>
            )}
            
            {/* WhatsApp Display */}
            {selectedCustomer?.phone && (
              <div className="bg-white rounded border border-blue-300 p-3">
                <div className="flex items-center gap-3">
                  <span className="text-2xl">📱</span>
                  <div className="flex-1">
                    <div className="font-semibold text-sm">WhatsApp</div>
                    <div className="text-xs text-gray-600">{selectedCustomer.phone}</div>
                  </div>
                </div>
              </div>
            )}
            
            {!selectedCustomer?.email && !selectedCustomer?.phone && (
              <div className="bg-red-50 border border-red-300 rounded p-3 text-sm text-red-700">
                ⚠️ Kunde hat weder Email noch Telefonnummer hinterlegt
              </div>
            )}
          </div>
          
          <div className="bg-gray-50 border rounded p-3 text-xs text-gray-600">
            <strong>Hinweis:</strong> Der Kunde erhält einen sicheren Link per Email UND WhatsApp (falls beide hinterlegt), um seine Kreditkarte selbst zu hinterlegen.
          </div>
          
          <div className="flex flex-col gap-2 pt-2">
            <Button
              onClick={onSendPaymentLink}
              disabled={!selectedCustomer?.email && !selectedCustomer?.phone}
              className="w-full"
            >
              📧📱 Link senden
            </Button>
            <Button
              variant="ghost"
              onClick={() => onOpenChange(false)}
              className="w-full"
            >
              Abbrechen
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SendPaymentLinkDialog;
